import { PendingButton } from '../components/common/PendingButton';
import { G } from './glyphs';

// THE GREY TIER, AS A COMPONENT (request-a-stay AC23a).
//
// The prototype draws *That didn't reach us* (2.4 step 3, `c9net`) as a whole
// page for a screenshot that did not send. Here it is the same tone and the
// same promise in a card: grey, because nothing was read and nothing judged;
// *no signal*, because that is where it stopped; and a retry. It sits under
// the calendar on step 2 and under the button on step 3.
//
// IT NEVER SAYS SIGNED OUT (row 3's lesson). A 401 goes to the locked-out page
// before this is ever drawn; everything this card is shown for is a connection
// the customer can try again.

const WHAT = {
  calendar: 'The calendar didn’t load. Your dates are safe — try again in a moment.',
  send: 'Nothing was sent. Your request is still here — try again in a moment.',
} as const;

export function ReachFailure({ what, onRetry, busy = false }: { what: keyof typeof WHAT; onRetry: () => void; busy?: boolean }) {
  return (
    <div className="cp-card msg msg-quiet cp-reach" role="alert">
      <span className="msg-ic" aria-hidden="true">{G.noSignal({ size: 15 })}</span>
      <span className="msg-txt">
        <b>We can’t reach the kennel</b>
        <small>{WHAT[what]}</small>
      </span>
      {/* Busy while the retry is out — the one button rule (PendingButton). */}
      <PendingButton className="cp-btn soft sm" busy={busy} onClick={onRetry}>
        Try again
      </PendingButton>
    </div>
  );
}
